import {useRouter} from '@s-ui/react-router'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {ROUTES} from '../../../../../config/index.js'

const RESERVATION_RETRIEVE_CLICKED = 'Reservation Retrieve Clicked'

export const useNavigationTransactionRefundReservation = () => {
  const {push} = useRouter()
  const {track} = useAnalyticsTrack()

  const navigation = interactionUrl => {
    const {searchParams} = new URL(interactionUrl)
    const reservationId = searchParams.get('reservationId')
    const adId = searchParams.get('adId')

    track({
      event: RESERVATION_RETRIEVE_CLICKED,
      data: {
        products: [{id: adId, category: 'ads', price: 0, quantity: 0}]
      }
    })

    push(`${ROUTES.RESERVATION.REFUND}?reservationId=${reservationId}&adId=${adId}`)
  }

  return navigation
}
